import { Navigate } from 'react-router';

import { useTypedParams } from '@sorare/routing';
import { ANY_SPORT_MARKET_WHEEL } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { isRarityStr } from '@sorare/core/src/lib/so5';
import { Wheel } from '@sorare/marketplace/src/components/Wheel';

import type { PageParams } from './__generated__/routeParams.ts';

const MarketWheelRarityPage = () => {
  const { rarity } = useTypedParams<PageParams>();
  const { generateSportContextPath } = useSportContext();

  if (!isRarityStr(rarity)) {
    return (
      <Navigate to={generateSportContextPath(ANY_SPORT_MARKET_WHEEL)} replace />
    );
  }

  return <Wheel rarity={rarity} />;
};
export default MarketWheelRarityPage;
